// in the case of grow this list we should move logic to the <Layout /> component property like a 'hideConnectionButton'
export default [
    '/_site/[city]/full-buy',
    '/_site/[city]/constructor',
    '/_site/[city]/novosel',
    '/_site/[city]/order/[order-id]/address',
    '/_site/[city]/order/[order-id]/contacts',
    '/_site/[city]/order/[order-id]/create-agreement',
    '/_site/[city]/order/[order-id]/final',
    '/_site/[city]/order/[order-id]/time-slots',
];
